/* unplugin-vue-components disabled */import { render } from "./KilaKilaTagCard.vue?vue&type=template&id=78f5dd86&scoped=true"
import script from "./KilaKilaTagCard.vue?vue&type=script&lang=js"
export * from "./KilaKilaTagCard.vue?vue&type=script&lang=js"

import "./KilaKilaTagCard.vue?vue&type=style&index=0&id=78f5dd86&scoped=true&lang=css"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f5dd86"]])

export default __exports__